export default "./dist/stdassets/images/icons/coordinate-tracker.png";